var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilefooterOrderbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#111324;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32017",
    "data-name": "Group 32017"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74375",
    "data-name": "Path 74375",
    className: "cls-1",
    d: "M474.94,255v104.3a8.14,8.14,0,0,1-5.12,8.54Q365.63,420,261.58,472.47c-5.72,2.87-6,2.68-6-3.66q0-104-.12-208.08a8.89,8.89,0,0,1,6-9.11q69.94-35,139.79-70.13,34-17.1,68-34.31c5.51-2.78,5.69-2.68,5.69,3.51Q475,202.83,474.94,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74376",
    "data-name": "Path 74376",
    className: "cls-1",
    d: "M168.72,297.84a10.43,10.43,0,0,0,.64-5.71V223c0-5.46.4-5.72,5.26-3.3,21.83,10.92,43.66,21.93,65.5,32.79a6.79,6.79,0,0,1,4.27,7q-.12,105,0,210c0,5.46-.42,5.74-5.26,3.31l-210-105.57A6.48,6.48,0,0,1,25,360.66q.12-105.53,0-211c0-4.51,1.45-4.69,5-2.9q35.72,18.17,71.61,36.08a7.11,7.11,0,0,1,4.46,7.39c-.13,23.56,0,47.12-.16,70.68,0,4.52,1.2,6.27,6,5.95,7-.34,14,0,21-.14a10.91,10.91,0,0,1,8.83,3.71c7.74,8.1,15.64,16,23.5,24A34.7,34.7,0,0,0,168.72,297.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74377",
    "data-name": "Path 74377",
    className: "cls-1",
    d: "M467.26,135c-.73,1.77-2.46,2.18-4,2.92q-25.93,13.08-51.9,26.1L254,243.44a7.33,7.33,0,0,1-7.46.3c-22-11.22-44.12-22.27-66.17-33.41-1.39-.71-3.71-.93-3.53-3,.11-1.53,2.18-1.87,3.47-2.57q101.22-54.1,202.27-108.25a9.79,9.79,0,0,1,10.21-.14C416.1,108.33,439.56,120,463,131.83,464.62,132.63,466.61,133,467.26,135Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74378",
    "data-name": "Path 74378",
    className: "cls-1",
    d: "M112.12,175.76c-1.33-.56-2.58-1-3.75-1.59q-36-18.15-72-36.36c-1.37-.7-3.69-1-3.48-3s2.38-2.14,3.83-2.88L173.25,63.38q36-18.12,72-36.39a9.26,9.26,0,0,1,9.35,0c21.28,10.86,42.67,21.5,64,32.26,1.55.77,4,1.11,4,3.21S320,64.87,318.5,65.7Q233.27,111.35,148,157l-31.75,17C114.9,174.53,113.51,175.08,112.12,175.76Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilefooterOrderbox);
export default __webpack_public_path__ + "static/media/Mobilefooter_orderbox.bfe01aa3225dd6524cac407f7df9c95a.svg";
export { ForwardRef as ReactComponent };